export enum ShopTypeEnum {
  PosOrder = 'PosOrder',
  PosOrderWebshop = 'PosOrderWebshop',
  SaleOrderWebshop = 'SaleOrderWebshop'
}
